import config from '../../config/config';

export const recommendedJourneyTemplateIds: string[] = config.templateIds.recommended as unknown as string[];
